<template>
  <div class="general-background" style="font-family: cerebriSansReg">
    <b-row>
      <b-col>
        <div style="text-align: center;">
          <div
            style="margin: 30px;"
          >If you are pre-authorized visit, please show your QR code in the scanner</div>
          <div style="max-width: 600px; margin-left: auto; margin-right: auto;">
            <qrcode-stream @decode="onDecode"></qrcode-stream>
          </div>
        </div>
      </b-col>
      <b-col>
        <div style="text-align: center;">
          <div
            style="margin: 30px;"
          >If you are not a pre-authorized visit, please scan this QR code and fill the form</div>
          <qriously :value="tempQR" :size="500" />
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import * as firebase from "firebase/app";
import "firebase/firestore";
import Vue from "vue";
import VueQriously from "vue-qriously";
import VueQrcodeReader from "vue-qrcode-reader";
import VueSwal from "vue-swal";
import axios from "axios";

Vue.use(VueQrcodeReader);
Vue.use(VueQriously);
Vue.use(VueSwal);

export default {
  name: "Kiosk",
  data: () => ({
    formGoodFormat: {},
    camera: "front",
    tempQR:
      "https://app.umonite.com/f?na=Visitor%20Demo&id=UXxmatZub6I4bpgAOuh7&n=Name%20(Invented)&t=1&n=Visiting&t=1&n=Purpose%20of%20visit&t=1&n=Are%20you%20interested%20in%20UMonite%3F&t=1"
  }),
  methods: {
    onDecode(decodedString) {
      var self = this;
      var obj = JSON.parse(decodedString);
      var id = obj.id;
      var visitName = decodeURI(obj.visitName);
      var msg = visitName + "has arrived.";
      firebase
        .firestore()
        .collection("users")
        .doc("IquUhi0v9FcIaLsdHjrHqm8ok6t2")
        .collection("visitors")
        .doc(id)
        .update({
          arrivalTT: Date.now()
        })
        .then(function() {
          // Send a POST request
          axios({
            method: "post",
            url: "https://fcm.googleapis.com/fcm/send",
            headers: {
              "Content-Type": "application/json",
              Authorization:
                "key=AAAAtCCOWck:APA91bGksC4N_Wety_0nVbbXEs5jMvv8IZEtF2zTJeH7mRLFQC0exlO7skkdmW6xY_KHRGUQbPI_8K3W0QGctLzTWuAVtIwbOC9sncD9AYjWxj9lkqSh_xzs_GeCrEz4nO9uNXxUC5fj"
            },
            data: {
              to: "/topics/pato",
              notification: {
                body: "Confirm your visit in the visitor section",
                title: msg,
                android_channel_id: "general",
                content_available: true,
                priority: "high",
                sound: "sound"
              }
            }
          }).then(function(response) {
            // handle success
            console.log(response);
            self.$swal({
              title: "Perfect!",
              text: "The user have been notified that you are here.",
              icon: "success"
            });
          });
        })
        .catch(function(error) {
          self.$swal({
            title: "Something went wrong!",
            text: "Please try again",
            icon: "error"
          });
        });
    }
  }
};
</script>